import React, { Component } from 'react'
import { isAuthenticated } from '../auth';
import { singlePost, update } from './apiPost'
import { Redirect } from 'react-router-dom';
import LoadingAnim from '../core/LoadingAnim';
//import DefaultPhoto from '../assets/default-post.jpg';

class EditPost extends Component {
    constructor() {
        super();
        this.state = {
            id: '',
            title: '',
            body: '',
            photo: '',
            redirectToProfile: false,
            error: '',
            fileSize: 0,
            loading: true
        }
    }

    init = postId => {
        singlePost(postId).then(data => {
            if (data.error) {
                this.setState({ redirectToProfile: true });
            } else {
                this.setState({
                    id: data._id,
                    title: data.title,
                    body: data.body,
                    error: "",
                    loading: false 
                });
            }
        })
    }

    componentDidMount() {
        this.postData = new FormData();
        const postId = this.props.match.params.postId;
        this.init(postId);
    }

    isValid = () => {
        const { title, body, fileSize } = this.state;

        if (fileSize > 1000000) {
            this.setState({ error: "Fils size must be less than 1MB.", loading: false });
            return false;
        }

        if (title.length === 0 || body.length === 0) {
            this.setState({ error: "Please fill in all the fields.", loading: false });
            return false;
        }

        return true;
    };


    handleChange = name => event => {
        this.setState({ error: "" });
        const value = name === "photo" ? event.target.files[0] : event.target.value;
        const fileSize = name === "photo" ? event.target.files[0].size : 0;
        this.postData.set(name, value);
        this.setState({ [name]: value, fileSize });
        //console.log('postData:', this.postData);
        // update the image using FileReader //

        if (name === "photo") {
            const lReader = new FileReader();
            lReader.onload = function (e) {
                document.getElementById('post_photo').setAttribute('src', e.target.result);
            }
            lReader.readAsDataURL(event.target.files[0]);
        }
    }

    clickSubmit = event => {
        event.preventDefault();

        if (this.isValid()) {
            this.setState({ loading: true });

            const postId = this.state.id;
            const token = isAuthenticated().token;
            update(postId, token, this.postData).then(data => {
                if (data.error) {
                    this.setState({ error: data.error });
                } else {
                    this.setState({
                        loading: false,
                        title: '',
                        body: '',
                        photo: '',
                        redirectToProfile: true
                    });
                }
            })
        }
    }

    editPostForm = (title, body, loading) => (
        <form>
            <div className="form-group">
                <label className="text-muted">Post Photo</label>
                <input onChange={this.handleChange("photo")} type="file" accept="image/*" className="form-control" />
            </div>
            <div className="form-group">
                <label className="text-muted">Post Title</label>
                <input onChange={this.handleChange("title")} type="text" className="form-control" value={title} />
            </div>
            <div className="form-group">
                <label className="text-muted">Post</label>
                <textarea onChange={this.handleChange("body")} type="text" className="form-control" value={body} />
            </div>
            <button onClick={this.clickSubmit} className="btn btn-raised btn-success">Update Post</button>
        </form>
    )

    render() {
        const { id, title, body, redirectToProfile, loading, error } = this.state;
        const photoUrl = `${process.env.REACT_APP_API_URL}/post/photo/${id}`;

        if (redirectToProfile) {
            return <Redirect to={`/user/${isAuthenticated().user._id}`} />
        }
        return (
            <div className="container">
                <h2 className="mt-5">Edit Post: {title}</h2>
                {loading ? <LoadingAnim /> : <img
                    id="post_photo"
                    src={photoUrl}
                    //onLoad={() => this.setState({loading: false})}
                    //onError={i => (i.target.src = `${DefaultPhoto}`)}
                    className="img-thumbnail img-fluid"
                    style={{ width: 'auto', maxHeight: 300, margin: 'auto' }}
                    alt={title}
                />}
                {!loading ? this.editPostForm(title, body) : <></>}
                <div className="alert alert-danger" style={{ visibility: error ? "visible" : "hidden" }}>
                    {error}
                </div>
            </div>
        )
    }
}

export default EditPost;